import React from 'react';
import { motion } from 'framer-motion';
import ContactForm from '../components/ContactFormElevated';
import ParallaxBackground from '../components/ParallaxBackground';

const CommercialRealEstate = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen"
    >
      <ParallaxBackground 
        image="/images/boathouse-row.jpg"
        className="py-32"
        overlay={true}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 text-white">
            Commercial Real Estate
          </h1>
          <p className="text-xl md:text-2xl text-gray-200 max-w-3xl mx-auto">
            Specialized closing services for commercial property transactions
          </p>
        </div>
      </ParallaxBackground>

      <section className="py-16 bg-eagle-light-gray">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-eagle-dark mb-4">
              Commercial Real Estate Services
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Navigating a commercial real estate transaction requires specialized knowledge and expertise. At Eagle Closing, we offer comprehensive closing services tailored specifically to commercial real estate transactions. Our experienced team is dedicated to ensuring a smooth and efficient closing process for commercial property owners and investors.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                title: 'Expert Guidance',
                description: 'Commercial real estate transactions involve unique considerations, such as zoning, leasing, and financing. Our team provides expert guidance and support throughout the entire closing process, helping you navigate complex legal and financial aspects.',
              },
              {
                title: 'Contract Review',
                description: 'Our professionals meticulously review the purchase agreement, lease agreements, and other relevant contracts, ensuring that all terms and conditions align with your expectations and protect your interests.',
              },
              {
                title: 'Title Examination and Insurance',
                description: 'We conduct a thorough title examination to identify any potential issues, liens, or encumbrances that may affect the property\'s ownership. Additionally, we assist in obtaining title insurance, providing you with protection and peace of mind regarding the property\'s ownership.',
              },
              {
                title: 'Due Diligence Coordination',
                description: 'We assist in coordinating due diligence efforts, such as property inspections, environmental assessments, and appraisals. Our team ensures that all necessary inspections and assessments are conducted to mitigate risks associated with the property.',
              },
              {
                title: 'Document Preparation and Review',
                description: 'We handle the preparation and review of all closing documents, including deeds, mortgages, leases, and closing statements. Our attention to detail ensures that all documents are accurate, compliant with legal requirements, and protect your rights as a commercial property owner.',
              },
              {
                title: 'Coordination with Stakeholders',
                description: 'We act as a central point of contact, coordinating with all relevant stakeholders involved in the transaction, including buyers, sellers, lenders, attorneys, and real estate agents. Our team facilitates clear communication and timely exchange of information, ensuring a smooth and efficient closing process.',
              },
            ].map((service, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
              >
                <h3 className="text-xl font-semibold text-eagle-dark mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600">
                  {service.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <p className="text-lg text-gray-700 mb-8">
              At Eagle Closing, we understand the unique needs of commercial real estate transactions and the importance of a successful closing. We strive to provide exceptional service and support, tailored specifically to commercial property owners and investors.
            </p>
            <p className="text-lg text-gray-700 mb-8">
              Contact us today to learn more about our commercial real estate services and how we can assist you in achieving a smooth and successful closing. Trust Eagle Closing to be your reliable partner throughout your commercial real estate journey, ensuring a seamless transition and protecting your investment.
            </p>
          </div>
        </div>
      </section>
      
      {/* Contact Form with Parallax */}
      <ContactForm backgroundImage="/images/benjamin-franklin-bridge.jpg" />
    </motion.div>
  );
};

export default CommercialRealEstate;

